export default {

    // Scroll to first error of the page
    scrollToFirstError() {
        try {
            const items = document.getElementsByClassName('is-invalid');
            if (items.length) {
                const element = items[0];
                const headerOffset = 75;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        } catch (error) {
            // ...
        }

    },

    // Fill object from another object
    loadObjectProps(src, dst) {
        for (let field in src) {
            if (src.hasOwnProperty(field) /*&& dst.hasOwnProperty(field)*/) {
                if (typeof src[field] !== 'undefined' && src[field] !== null && src[field] !== '') {
                    dst[field] = src[field];
                }
            }
        }
    },

    // Number format
    numberFormat(number, decimals, dec_point = '.', thousands_sep = ' ') {
        // Strip all characters but numerical ones.
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.round(n * k) / k;
            };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    }

};
